import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'

/**
 * 应用入口文件
 * 挂载React应用到DOM
 */

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);